import { createContext, useContext, useState, useCallback } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export const PRICE = 1500;
export const BRAND = {
  name: "Full Send Apparel",
  domain: "Fullsendapparel.com",
  location: "Nairobi, Kenya",
  phones: ["+254 740 749 474", "+254 724 793 963"],
  whatsapp: "254740749474",
  instagram: "fullxsend.co",
};

const keyOf = (i) => `${i.product_id}-${i.color}-${i.size}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const addItem = useCallback((item, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => keyOf(i) === keyOf(item));
      if (idx > -1) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...prev, { ...item, quantity }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((item, delta) => {
    setItems((prev) =>
      prev
        .map((i) => (keyOf(i) === keyOf(item) ? { ...i, quantity: i.quantity + delta } : i))
        .filter((i) => i.quantity > 0)
    );
  }, []);

  const removeItem = useCallback((item) => {
    setItems((prev) => prev.filter((i) => keyOf(i) !== keyOf(item)));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((a, i) => a + i.quantity, 0);
  const total = items.reduce((a, i) => a + i.quantity * (i.price || 1500), 0);

  return (
    <CartCtx.Provider
      value={{ items, open, setOpen, addItem, updateQty, removeItem, clear, count, total, keyOf }}
    >
      {children}
    </CartCtx.Provider>
  );
};
